import {I18N} from '@gravity-ui/i18n';
import {Lang} from 'common/constants';
import {get} from 'lodash';

export const lang = get(window, 'YC.lang') || Lang.En;
const keysets = window.YC_I18N || {};
export const i18nBase = new I18N();

i18nBase.registerKeysets(lang, keysets);
i18nBase.setLang(lang);

const i18n = i18nBase.i18n.bind(i18nBase);

export default i18n;
